<template>
    <div class="player">
        <base-settings-row
            class="is-centered"
            config-title="Player type"
            input-type="radio"
            :fields-config="playerTypeConfig"
            :binded-value="settings.sticky"
            settings-key="sticky"
            :input-class="['is-round']"
            :is-active="hasStickyPlayers"
            @change="value => $emit('change', value)"
        />
        <base-settings-row
            v-if="settings.sticky === true"
            :binded-value="settings.position"
            :fields-config="position"
            :input-class="['is-round']"
            :is-active="hasStickyPlayers"
            class="is-centered"
            config-title="Player position"
            input-type="radio"
            settings-key="position"
            @change="value => $emit('change', value)"
        />
        <base-settings-row
            config-title="Player controls"
            input-type="checkbox"
            :fields-config="controlsConfig"
            :binded-value="settings.controls"
            settings-key="controls"
            :is-active="hasSpeedRewind"
            @change="value => $emit('change', value)"
        />
        <base-settings-row
            config-title="Buttons"
            input-type="checkbox"
            :fields-config="buttonsConfig"
            :binded-value="settings.buttons"
            settings-key="buttons"
            :available-options="availableButtons"
            @change="value => $emit('change', value)"
        />
        <div class="settings-field">
            <p class="title">
                Cover Artwork:
            </p>
            <div class="options">
                <base-checkbox
                        :container-class="['settings-option']"
                        label="Show cover"
                        :value="true"
                        :values="settings.coverDisplay"
                        @change="value => $emit('change', { coverDisplay: value })"
                />
                <div
                        v-if="settings.coverDisplay"
                        class="row-container is-centered"
                    >
                        <base-checkbox
                            :container-class="['settings-option']"
                            label="Go to URL on click"
                            :value="true"
                            :values="coverLink"
                            @change="value => coverLink = value"
                        />
                        <input
                            v-model="coverUrl"
                            type="text"
                            placeholder="https://"
                            :disabled="! coverLink"
                            @blur="prefixUrl"
                        >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import playerSettings from '@/utils/config/playerSettings';
import prefixUrlInput from '@/utils/form/prefixUrlInput';
import { Feature, hasFeature } from '@/utils/show';

const {
    buttonsConfig,
    controlsConfig,
    freeOptions,
    playerTypeConfig,
    position,
} = playerSettings;

export default {
    props: {
        settings: {
            type: Object,
            required: true,
        },
        show: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        buttonsConfig,
        controlsConfig,
        freeOptions,
        playerTypeConfig,
        position,
    }),

    computed: {
        coverLink: {
            /**
             * Gets computed value
             *
             * @returns {string} Cover link
             */
            get() {
                return this.settings.cover.link;
            },

            /**
             * Set value
             *
             * @param   {string}  value  Value to be set
             *
             */
            set(value) {
                this.$emit('nested-config-change', { parent: 'cover', data: { link: value } });
            },
        },

        /**
         * Checks if the show has sticky players feature enabled.
         *
         * @returns {boolean} True if the show has sticky players feature.
         */
        hasStickyPlayers() {
            return hasFeature(this.show, Feature.StickyPlayers);
        },

        /**
         * Checks if the show has speed/rewind controls feature enabled.
         *
         * @returns {boolean} True if the show has speed/rewind controls feature.
         */
        hasSpeedRewind() {
            return hasFeature(this.show, Feature.SpeedRewind);
        },

        /**
         * Returns the list of available buttons.
         *
         * @returns {Array} List of available buttons.
         */
        availableButtons() {
            return [
                hasFeature(this.show, Feature.DownloadButton) && 'download',
                hasFeature(this.show, Feature.ShareButton) && 'share',
                hasFeature(this.show, Feature.SubscribeButton) && 'subscribe',
            ].filter((button) => !! button);
        },

        coverUrl: {
            /**
             * Gets computed value
             *
             * @returns {string} Cover link
             */
            get() {
                return this.settings.cover.url;
            },

            /**
             * Set value
             *
             * @param   {string}  value  Value to be set
             *
             */
            set(value) {
                this.$emit('nested-config-change', { parent: 'cover', data: { url: value } });
            },
        },
    },

    methods: {
        /**
         * Prefixes Url
         *
         */
        prefixUrl() {
            this.coverUrl = prefixUrlInput(this.coverUrl);
        },
    },
};
</script>
